<script lang="ts">
	import classNames from 'classnames';
	import { twMerge } from 'tailwind-merge';
	import { CardTag } from '../../NewsCard/CardTag';
	import { TagText } from '../../NewsCard/CardTag/TagText';
	import { GlobalRoutes } from '#lib/features/navigation/constants/global-routes.js';
	import { NewsMixpanelEvents } from '#lib/features/news/constants/mixpanel-events.js';
	import { ArticleSearchCategory } from '#lib/websites/news/constants/categories.js';
	import { page } from '$app/state';
	import { ShoutoutIcon } from '$global/assets/icons/ShoutoutIcon';
	import { capitalizeFirstLetters } from '$global/utils/capitalizeFirstLetters';
	import { track } from '$global/utils/track';

	let {
		dataCy,
		category,
		onClick = undefined,
		forceShowGlobalNav = undefined,
		...rest
	}: Props = $props();

	interface Props {
		dataCy: string;
		class?: string;
		category: string;
		onClick?: (() => void) | undefined;
		forceShowGlobalNav?: boolean | undefined;
	}

	// The URL param is the fallback authority: on error pages (and any route
	// whose load doesn't provide showGlobalNav) page.data is empty, and
	// app-mode (global_nav=0) visitors must stay on navless links.
	let showGlobalNav = $derived(
		forceShowGlobalNav ??
			page.data.showGlobalNav ??
			page.url.searchParams.get('global_nav') !== '0'
	);
</script>

<CardTag
	showNewVersion
	onclick={() => {
		if (onClick) {
			onClick();
		}
		track(NewsMixpanelEvents.Search, { category });
	}}
	href={(() => {
		if (category === ArticleSearchCategory.shoutouts) {
			return `${GlobalRoutes.NewsHome}${showGlobalNav ? `` : `?global_nav=0`}`;
		} else {
			return `${GlobalRoutes.NewsHome}${
				showGlobalNav
					? `?category=${category === 'nft' ? 'NFT' : category}`
					: `?global_nav=0&category=${category === 'nft' ? 'NFT' : category}`
			}`;
		}
	})()}
	class={twMerge(classNames('h-[20px] border-blue-600'), rest.class)}
	{dataCy}
>
	{#if category === ArticleSearchCategory.shoutouts}
		<ShoutoutIcon color="blue-600" class="mr-[-0.25rem] ml-1.5 h-3 w-3" />
	{/if}

	<TagText
		color="blue"
		isActive={false}
		class="font-semibold"
		label={(() => {
			if (category === 'nft') {
				return 'NFT';
			}

			if (category === ArticleSearchCategory.shoutouts) {
				return 'Top';
			}

			return capitalizeFirstLetters(category);
		})()}
	/>
</CardTag>
